export default {
  "Your registration is successful. Please check more race information on your personal center.": "¡Felicidades! Tu registro ha sido exitoso. Por favor, consulta más información sobre la carrera en tu Centro Personal.",
  "Your registration has been successfully submitted and is currently under review. Since this is a professional race, your qualification needs to undergo evaluation. Please check the status on your personal center.":"Tu registro ha sido enviado con éxito y está actualmente en revisión. Dado que esta es una carrera profesional, tu calificación necesita ser evaluada. Por favor, consulta el estado en tu Centro Personal.",
  "The race is coming soon. Please stay tuned for updates.": "La carrera se acerca. Por favor, mantente atento a las actualizaciones.",
  "Please read the Terms & Conditions and Privacy Statement before checking the button.":
    "Por favor, lee los Términos y Condiciones y la Declaración de Privacidad antes de marcar la casilla.", // 协议没选
  "It's working too fast. Please try again in 10 seconds.":
    "It's working too fast. Please try again in 10 seconds.", // 10秒后才能二次验证
  "Invitation code": "Código de invitación", // 1003
  "Invitation code error": "Error en el código de invitación", // 失败提示用于else
  // 注册页开始
  Name: "Nombre",
  Age: "Edad",
  "Please do not register if you are under 18 years old":
    "Por favor, no te registres si eres menor de 18 años",
  Gender: "Género",
  Male: "Masculino",
  Female: "Femenino",
  Other: "Otro",
  Email: "Correo electrónico",
  "Phone number of emergency contact person":
    "Número de teléfono de contacto en caso de emergencia",
  "Please share your professional experience":
    "Por favor, comparte tu experiencia profesional",
  "Previous race certificate within 3 years":
    "Certificado de carrera anterior dentro de los últimos 3 años",
  "Your information is incorrect": "Tu información es incorrecta",
  // 注册页结束
  // 报名成功开始
  Pending: "Pendiente",
  "Congratulations!": "¡Felicidades!",
  // 报名成功结束
  advertisement: {
    title:
      "Imagine if your pictures have sound! Check out this video to see how!",
    desc: "Let's give a huge cheer for your fantastic photos! 👏✨",
  },
  common: {
    "Personal page": "Centro Personal",
    "Sign out": "Cerrar sesión",
    "Sign in": "Iniciar sesión",
    professionalRace: "Carrera profesional",
    runForFun: "Carrera recreativa",
    introduction: "Introducción a la Xiaomi POP Run 2024",
    termsAndCondition: "Términos y Condiciones",
    privacyStatement: "Declaración de privacidad",
    title: "Xiaomi POP Run 2024",
    mile: "10km",
    mile2: "",
    btn: {
      confirm: "Confirmar",
    },
  },
  home: {
    btn: {
      runNow: "Run Now",
    },
  },
  register: {
    disclaimer:
      "Aviso legal: Antes de participar en la carrera, realiza una evaluación completa de tu bienestar físico para confirmar que cumples con los estándares requeridos.",
    submit: "Enviar",
  },
  details: {
    area: {
      p: "Carrera profesional:",
      runTime: "Carrera recreativa:",
    },
    card: {
      countdownToRegistrationStarts: "Cuenta regresiva para la inscripción",
      countdownToRegistrationEnds: "El registro termina en",
      Days: "Días",
      Hours: "Horas",
      Minutes: "Minutos",
    },
    btn: {
      register: "Registrar",
      runNow: "Run Now",
      enrollmentIsFull: "Registro completo",
      registrationIsClosed: "Registro cerrado",
    },
    desc: {
      invitationCodeRegistration:
        "El periodo actual es solo para registro con código de invitación",
    },
  },
  review: {
    title: "No puedes cambiar la operación una vez que haya sido confirmada.",
    more: "Más",
    text: "Desactivar recordatorio",
    btn: {
      agree: "Aceptar",
      disagree: "Rechazar",
    },
  },
  end: {
    logout: "Log out",
    infoHeader: {
      title: "POP Run 2024",
      runTime: "Running Time：",
      btn: {
        runNow: "Run Now",
        pending: "Pendiente",
        registered: "Registrado",
        rejected: "Application failed",
        waiting: "Esperando confirmación oficial",
        unfortunately: "Lamentablemente, tu solicitud ha sido denegada.",
      },
    },
    application: "Solicitudes de registro",
    checkMore: {
      about: "Descubre más aquí:",
    },
    participationHistory: {
      header: "Historial de participación",
      noHistory: "No history",
      h2: "Xiaomi Pop Run { year }-Professional Race",
    },
    share: {
      name: "Nombre",
      country: "País",
      download: "Descargar",
      shareOn: "Comparte en:",
      content:
        "con #XiaomiPOPRun2024. ¡Invita a más personas a unirse a la carrera!",
      description:
        "Invite more friends to join the race and feel passion beyond limits!",
    },
  },
  footer: {
    copyright: "Copyright©2016-{year} Xiaomi.com, All Rights Reserved",
  },
  dialog: {
    logOut: {
      content: "Please check if you want to log out",
      confirm: "Confirmar",
      cancle: "Cancle",
    },
    countrySelect: {
      headerTitle: "País",
      headerContent:
        "Country-City name The following list displays the hosting cities for the Xiaomi POP Run 2024",
      rowNow: "Run Now",
      footerContent:
        "*Para algunos países, el registro se redirigirá a un sitio web externo.",
    },
  },
};
